import register from '../register';
const rAF = window.requestAnimationFrame;
const cAF = window.cancelAnimationFrame;

class Carousel {
  constructor( selector, opts = {} ) {
    this.el = document.querySelector( selector );
    this.items = this.el.querySelectorAll( `${ selector }__item` );
    this.images = document.querySelectorAll( `${ selector }__img` );
    this.progressBars = this.el.querySelectorAll( `${ selector }__bar` );
    this.currentIndex = 0;
    this.speed = opts.speed || 2000;
    this.running = false;

    this.frame = null;
    this.start = null;
    this.elapsed = null;
    this.duration = this.speed;

    this.onClick = this.onClick.bind( this );
    this.loop = this.loop.bind( this );
    this.createIndexes();
    this.bindEvents();
    this.init();
  }

  init() {
    if ( !this.running ) {
      this.running = true;
    }

    rAF( this.loop );
  }

  loop( now ) {
    if ( !this.running ) {
      return;
    }

    if ( !this.start ) {
      this.start = now;
    }

    this.elapsed = now - this.start;

    const percentage = this.elapsed / this.duration;
    const bar = this.progressBars[ this.currentIndex ];
    bar.style.transform = `scaleY(${ percentage })`;

    if ( this.elapsed < this.duration ) {
      this.frame = rAF( this.loop );
      return;
    }

    this.items.forEach( el => el.classList.remove('active') );
    this.images.forEach( el => el.classList.remove('active') );
    this.progressBars.forEach( el => el.style.transform = '' );
    this.currentIndex < this.items.length - 1
      ? this.currentIndex++
      : this.currentIndex = 0;
    this.items[ this.currentIndex ].classList.add('active');
    this.images[ this.currentIndex ].classList.add('active');
    this.start = null;
    this.frame = rAF( this.loop );
  }

  createIndexes() {
    this.items.forEach( ( el, index ) => el.dataset.index = index );
    this.images.forEach( ( img, index ) => img.dataset.index = index );
  }

  bindEvents() {
    this.items.forEach( el => el.addEventListener( 'click', this.onClick ) );
  }

  onClick( e ) {
    const index = e.currentTarget.dataset.index;
    if ( index === this.currentIndex ) {
      return;
    }
    this.running = false;
    cAF( this.frame );
    this.currentIndex = index;
    this.items.forEach( el => el.classList.remove('active') );
    this.images.forEach( el => el.classList.remove('active') );
    this.progressBars.forEach( el => el.style.transform = '' );
    this.items[ this.currentIndex ].classList.add('active');
    this.images[ this.currentIndex ].classList.add('active');
  }
}

register( 'progress-carousel', () => {

  new Carousel( '.progress-carousel', { speed: 5000 } );

});

export default undefined;
